import React from "react";
import { Container } from "reactstrap";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Homepage from "../homepage/Homepage";
import DetailsPage from "../detailsPage";
import Bonuses from "../bonuses";
import Casinos from "../online-casinos";
import SportsBetting from "../sports betting";
import Games from "../games";
import Auth from "../admin/auth";
import Dashboard from "../admin/dashboard";
import Footer from "./Footer";

import "./style.css";
import MainPage from "../admin/Tabs/Mainpage";
import AddNewCasino from "../admin/Tabs/Online Casino/AddNewCasino";
import CasinoLists from "../admin/Tabs/Online Casino/CasinoLists";
import CasinoCategories from "../admin/Tabs/Online Casino/CasinoCategories";
import AddNewSports from "../admin/Tabs/Sports Betting/AddNewSport";
import SportsBettingLists from "../admin/Tabs/Sports Betting/SportsBettingLists";
import SportsBettingCategories from "../admin/Tabs/Sports Betting/SportsBettingCategories";
import AddNewGame from "../admin/Tabs/Games/AddNewGame";
import GamesLists from "../admin/Tabs/Games/GamesLists";
import GamesCategories from "../admin/Tabs/Games/GamesCategories";
import AddNewBonus from "../admin/Tabs/Bonus/AddNew";
import BonusLists from "../admin/Tabs/Bonus/Lists";
import BonusCategories from "../admin/Tabs/Bonus/Categories";
import Settings from "../admin/Tabs/Settings";
import AddNewExclusiveDeal from "../admin/Tabs/Exclusice Deals/AddNew";
import ExclusiveList from "../admin/Tabs/Exclusice Deals/ExclusiveList";
import AuthenticatedRoute from "../../components/AuthenticatedRoute";
import { AboutUs } from "../about-us";
import { TermsAndConditions } from "../terms_and_conditions";
import { PlayResponsibly } from "../play_responsibly";
import { Imprint } from "../imprint";

const NotFound = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <h2 className="text-4xl text-gray-800">404 - Page Not Found</h2>
    </div>
  );
};

const MainRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="details" element={<DetailsPage />} />
        <Route path="bonuses" element={<Bonuses />} />
        <Route path="casinos" element={<Casinos />} />
        <Route path="sports-betting" element={<SportsBetting />} />
        <Route path="games" element={<Games />} />
        <Route path="about-us" element={<AboutUs />} />
        <Route path="play-responsibly" element={<PlayResponsibly />} />
        <Route path="terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="imprint" element={<Imprint />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
};

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Auth />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const AdminRoutes = () => {
  return (
    <Dashboard>
      <Routes>
        <Route path="/" element={<Navigate to="/vips/mainpage" replace />} />
        <Route
          path="mainpage"
          element={<AuthenticatedRoute element={<MainPage />} />}
        />
        {/* Online Casino */}
        <Route
          path="add-edit-casino"
          element={<AuthenticatedRoute element={<AddNewCasino />} />}
        />
        <Route
          path="casinos-list"
          element={<AuthenticatedRoute element={<CasinoLists />} />}
        />
        <Route
          path="casino-categories"
          element={<AuthenticatedRoute element={<CasinoCategories />} />}
        />
        {/* Sports Betting */}
        <Route
          path="add-edit-sport"
          element={<AuthenticatedRoute element={<AddNewSports />} />}
        />
        <Route
          path="sports-list"
          element={<AuthenticatedRoute element={<SportsBettingLists />} />}
        />
        <Route
          path="sport-categories"
          element={<AuthenticatedRoute element={<SportsBettingCategories />} />}
        />
        {/* Games */}
        <Route
          path="add-edit-game"
          element={<AuthenticatedRoute element={<AddNewGame />} />}
        />
        <Route
          path="games-list"
          element={<AuthenticatedRoute element={<GamesLists />} />}
        />
        <Route
          path="game-categories"
          element={<AuthenticatedRoute element={<GamesCategories />} />}
        />
        {/* Bonuses */}
        <Route
          path="add-edit-bonus"
          element={<AuthenticatedRoute element={<AddNewBonus />} />}
        />
        <Route
          path="bonus-list"
          element={<AuthenticatedRoute element={<BonusLists />} />}
        />
        <Route
          path="bonus-categories"
          element={<AuthenticatedRoute element={<BonusCategories />} />}
        />
        {/* Exclusive Deals */}
        <Route
          path="add-exclusive-deal"
          element={<AuthenticatedRoute element={<AddNewExclusiveDeal />} />}
        />
        <Route
          path="exclusive-list"
          element={<AuthenticatedRoute element={<ExclusiveList />} />}
        />
        {/* Settings */}
        <Route
          path="settings"
          element={<AuthenticatedRoute element={<Settings />} />}
        />
      </Routes>
    </Dashboard>
  );
};

const App = () => {
  return (
    <Container fluid className="p-0 m-0 bg-[#141414] h-screen w-full">
      <Router>
        <Routes>
          <Route path="/*" element={<MainRoutes />} />
          <Route path="/vips/login" element={<AuthRoutes />} />
          <Route path="/vips/*" element={<AdminRoutes />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </Container>
  );
};

export default App;
